import { Col, Form, Modal, Row } from "react-bootstrap";
import { Actions, onKeyDownForm } from "../../utils";
import DefaultButton from "../widgets/default-button";
import "../../assets/scss/components/modal.scss";

export const LabelModal: React.FC<any> = (props) => {
    const {
        show,
        mkey,
        model,
        setModel,
        closeModal,
        saveModal
    } = props;

    return (<>
        <Modal
            show={show}//showModal.label
            key={"modal_" + mkey}
            // size="lg" //'sm' | 'lg' | 'xl'
            backdrop="static"
            onHide={closeModal}
            centered
            className="custom-modal"
        >
            <Form
                noValidate
                className='custom-form'
                // validated={model.validate}
                onSubmit={saveModal}
                onKeyDown={onKeyDownForm}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{model.action === Actions.add ? "New Label" : "Label Edit"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {model.message !== '' ? (
                        <Row className="form-error">
                            <Form.Group>
                                <Col xs={12}>
                                    <Form.Label>{model.message}</Form.Label>
                                </Col>
                            </Form.Group>
                        </Row>
                    ) : (<></>)}
                    <Row>
                        <Col xs={12} md={3}>
                            <Form.Label>Full Title<span className="required">*</span></Form.Label>
                        </Col>
                        <Col xs={12} md={9}>
                            <Form.Control
                                required
                                disabled={model.action === Actions.delete}
                                type='text'
                                value={model.title}
                                onChange={(e) => setModel({ ...model, title: e.target.value })}
                                isInvalid={!model.validate && model.title === ""}
                            />
                            <Form.Control.Feedback type="invalid">
                                Title can not empty.
                            </Form.Control.Feedback>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col xs={12} md={3}>
                            <Form.Label>Series Code<span className="required">*</span></Form.Label>
                        </Col>
                        <Col xs={12} md={9}>
                            <Form.Control
                                required
                                disabled={model.action === Actions.delete}
                                type='text'
                                value={model.series_code}
                                onChange={(e) => setModel({ ...model, series_code: e.target.value })}
                                isInvalid={!model.validate && model.series_code === ""}
                            />
                            <Form.Control.Feedback type="invalid">
                                Alias can not empty.
                            </Form.Control.Feedback>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col xs={12} md={3}>
                            <Form.Label>Comment</Form.Label>
                        </Col>
                        <Col xs={12} md={9}>
                            <Form.Control
                                disabled={model.action === Actions.delete}
                                type='text'
                                value={model.comments}
                                onChange={(e) => setModel({ ...model, comments: e.target.value })}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <DefaultButton
                        className="small-button"
                        textColor="var(--color-primary)"
                        color="white"
                        borderColor="var(--color-primary)"
                        onClick={closeModal}
                    >
                        Close
                    </DefaultButton>
                    <DefaultButton
                        type="submit"
                        className="small-button"
                        color="var(--color-primary)"
                        textColor="white"
                        disabled={model.action === Actions.delete && model.message !== ''}
                    >
                        {model.action === Actions.add ? "Save" : model.action === Actions.edit ? "Save Changes" : "Delete"}
                    </DefaultButton>
                </Modal.Footer>
            </Form>
        </Modal>
    </>);
};